/**
 * AI Chat Service for Gifted Solutions
 * Provides intelligent responses for customer inquiries
 */

class AIChatService {
  constructor() {
    this.productDatabase = null; // Will be loaded from ProductContext
    this.categories = [];

    // Complete Gifted Solutions Product Catalog
    this.giftedSolutionsProducts = {
      'Arduino & Development Boards': [
        { name: 'Arduino Uno + USB Cable', price: 'K750', category: 'Arduino & Development Boards', description: 'Complete Arduino Uno R3 with USB cable for programming and power. Perfect for beginners and most popular Arduino board.', keywords: ['arduino', 'uno', 'usb', 'cable', 'beginner', 'r3'] },
        { name: 'Arduino Nano + Cable', price: 'K450', category: 'Arduino & Development Boards', description: 'Compact Arduino Nano with cable. Small form factor perfect for breadboard projects and space-constrained applications.', keywords: ['arduino', 'nano', 'compact', 'breadboard', 'small'] },
        { name: 'Atmega 328P Microcontroller Set', price: 'K400', category: 'Arduino & Development Boards', description: 'Atmega 328P microcontroller set for custom Arduino projects and circuit design.', keywords: ['atmega', '328p', 'microcontroller', 'custom', 'diy'] },
        { name: 'Arduino Nano Terminal Adapter', price: 'K250', category: 'Arduino & Development Boards', description: 'Terminal adapter for Arduino Nano making connections easier with screw terminals.', keywords: ['nano', 'terminal', 'adapter', 'screw', 'connection'] },
        { name: 'Arduino Mega Atmega2560 + Cable', price: 'K1000', category: 'Arduino & Development Boards', description: 'Arduino Mega with Atmega2560 and cable. More I/O pins and memory for complex projects.', keywords: ['arduino', 'mega', 'atmega2560', 'more pins', 'complex'] },
        { name: 'ESP8266 NodeMCU', price: 'K800', category: 'Arduino & Development Boards', description: 'ESP8266 NodeMCU with WiFi capability for IoT projects and wireless communication.', keywords: ['esp8266', 'nodemcu', 'wifi', 'iot', 'wireless'] },
        { name: 'ESP32 WiFi Module + OV2640 CAM', price: 'K800', category: 'Arduino & Development Boards', description: 'ESP32 with WiFi, Bluetooth and OV2640 camera module for vision and IoT projects.', keywords: ['esp32', 'wifi', 'bluetooth', 'camera', 'ov2640', 'vision'] },
        { name: 'ESP32 NodeMCU WROVER', price: 'K800', category: 'Arduino & Development Boards', description: 'ESP32 NodeMCU WROVER with extra PSRAM for memory-intensive applications.', keywords: ['esp32', 'nodemcu', 'wrover', 'psram', 'memory'] },
        { name: 'ESP32 S3 devitc WIFI+BLUETOOTH', price: 'K1000', category: 'Arduino & Development Boards', description: 'Latest ESP32-S3 development board with WiFi and Bluetooth for advanced IoT projects.', keywords: ['esp32', 's3', 'wifi', 'bluetooth', 'latest', 'advanced'] },
        { name: 'ZY-ESP32 WIFI+BLUETOOTH', price: 'K800', category: 'Arduino & Development Boards', description: 'ZY-ESP32 board with WiFi and Bluetooth capabilities for IoT and wireless projects.', keywords: ['zy-esp32', 'wifi', 'bluetooth', 'iot', 'wireless'] },
        { name: 'Arduino Starter Kit (UNO R3 Based)', price: 'K2000', category: 'Arduino & Development Boards', description: 'Complete Arduino starter kit based on UNO R3 with components, sensors, and project guide.', keywords: ['starter', 'kit', 'uno', 'r3', 'complete', 'beginner', 'components'] },
        { name: 'Arduino starter kit (Mega Based)', price: 'K2500', category: 'Arduino & Development Boards', description: 'Advanced Arduino starter kit based on Mega with extensive components for complex projects.', keywords: ['starter', 'kit', 'mega', 'advanced', 'complex', 'extensive'] }
      ],
      'Sensors & Modules': [
        { name: 'Fingerprint sensor FPM10A', price: 'K950', category: 'Sensors & Modules', description: 'High-quality FPM10A fingerprint sensor for biometric security and access control systems.', keywords: ['fingerprint', 'fpm10a', 'biometric', 'security', 'access'] },
        { name: 'MQ-3 Gas Sensor', price: 'K250', category: 'Sensors & Modules', description: 'MQ-3 alcohol and gas sensor for breath analyzer and gas detection projects.', keywords: ['mq-3', 'gas', 'alcohol', 'breath', 'analyzer'] },
        { name: 'DHT11 Temp & Humidity Sensor', price: 'K250', category: 'Sensors & Modules', description: 'DHT11 digital temperature and humidity sensor for weather monitoring and environmental control.', keywords: ['dht11', 'temperature', 'humidity', 'weather', 'environmental'] },
        { name: 'ACS712 Current Sensor', price: 'K250', category: 'Sensors & Modules', description: 'ACS712 current sensor for measuring AC/DC current in power monitoring applications.', keywords: ['acs712', 'current', 'sensor', 'power', 'monitoring', 'ac', 'dc'] },
        { name: 'ZMPT101B Voltage Sensor', price: 'K300', category: 'Sensors & Modules', description: 'ZMPT101B voltage sensor for AC voltage measurement and power monitoring systems.', keywords: ['zmpt101b', 'voltage', 'sensor', 'ac', 'power', 'monitoring'] },
        { name: 'IR Obstacle Avoidance Sensor', price: 'K250', category: 'Sensors & Modules', description: 'Infrared obstacle avoidance sensor for robotics and automation projects.', keywords: ['ir', 'infrared', 'obstacle', 'avoidance', 'robotics', 'automation'] },
        { name: 'PIR Motion Sensor (HC-SR501)', price: 'K250', category: 'Sensors & Modules', description: 'PIR motion sensor HC-SR501 for motion detection in security and automation systems.', keywords: ['pir', 'motion', 'hc-sr501', 'detection', 'security', 'automation'] },
        { name: 'HC-SR04 Ultrasonic Sensor', price: 'K250', category: 'Sensors & Modules', description: 'HC-SR04 ultrasonic distance sensor for ranging and obstacle detection applications.', keywords: ['hc-sr04', 'ultrasonic', 'distance', 'ranging', 'obstacle'] },
        { name: '10k Potentiometer', price: 'K100', category: 'Sensors & Modules', description: '10k ohm potentiometer for analog input and variable resistance applications.', keywords: ['10k', 'potentiometer', 'analog', 'variable', 'resistance'] },
        { name: 'LM35 Temperature Sensor', price: 'K250', category: 'Sensors & Modules', description: 'LM35 precision temperature sensor with linear output for temperature monitoring.', keywords: ['lm35', 'temperature', 'precision', 'linear', 'monitoring'] },
        { name: 'Soil Moisture Sensor', price: 'K250', category: 'Sensors & Modules', description: 'Soil moisture sensor for agricultural automation and plant monitoring systems.', keywords: ['soil', 'moisture', 'agricultural', 'plant', 'monitoring'] },
        { name: 'Arduino Sound Sensor', price: 'K250', category: 'Sensors & Modules', description: 'Sound sensor module for audio detection and sound-activated projects.', keywords: ['sound', 'sensor', 'audio', 'detection', 'activated'] },
        { name: 'Pulse Heart Rate Sensor', price: 'K250', category: 'Sensors & Modules', description: 'Pulse heart rate sensor for health monitoring and fitness tracking applications.', keywords: ['pulse', 'heart', 'rate', 'health', 'monitoring', 'fitness'] },
        { name: 'MQ-2 Smoke & LPG Gas Sensor', price: 'K250', category: 'Sensors & Modules', description: 'MQ-2 sensor for smoke and LPG gas detection in safety and alarm systems.', keywords: ['mq-2', 'smoke', 'lpg', 'gas', 'safety', 'alarm'] },
        { name: 'MQ-7 Carbon Monoxide & Gas Sensor', price: 'K300', category: 'Sensors & Modules', description: 'MQ-7 carbon monoxide and gas sensor for air quality monitoring and safety systems.', keywords: ['mq-7', 'carbon', 'monoxide', 'gas', 'air', 'quality', 'safety'] },
        { name: 'MQ-135 Air Quality Sensor', price: 'K300', category: 'Sensors & Modules', description: 'MQ-135 air quality sensor for detecting harmful gases and air pollution monitoring.', keywords: ['mq-135', 'air', 'quality', 'harmful', 'gases', 'pollution'] },
        { name: '1M Trimmer Potentiometer', price: 'K100', category: 'Sensors & Modules', description: '1 Megohm trimmer potentiometer for fine adjustment and calibration applications.', keywords: ['1m', 'trimmer', 'potentiometer', 'adjustment', 'calibration'] },
        { name: 'PZEM V3.0 Multi-Sensor', price: 'K1500', category: 'Sensors & Modules', description: 'PZEM V3.0 multi-sensor for voltage, current, power, AC frequency measurement in power monitoring.', keywords: ['pzem', 'v3.0', 'multi-sensor', 'voltage', 'current', 'power', 'frequency'] }
      ],
      'Display & Interface Modules': [
        { name: '16x2 LCD with I2C', price: 'K350', category: 'Display & Interface Modules', description: '16x2 character LCD display with I2C interface for easy connection and text display.', keywords: ['16x2', 'lcd', 'i2c', 'character', 'display', 'text'] },
        { name: '20x4 LCD Display', price: 'K450', category: 'Display & Interface Modules', description: '20x4 character LCD display for larger text display and menu systems.', keywords: ['20x4', 'lcd', 'display', 'character', 'large', 'menu'] },
        { name: '4x4 Membrane Keypad', price: 'K250', category: 'Display & Interface Modules', description: '4x4 membrane keypad for user input and control interface applications.', keywords: ['4x4', 'membrane', 'keypad', 'input', 'control', 'interface'] },
        { name: 'Micro SD Card Module', price: 'K250', category: 'Display & Interface Modules', description: 'Micro SD card module for data logging and storage applications.', keywords: ['micro', 'sd', 'card', 'module', 'data', 'logging', 'storage'] }
      ],
      'Communication Modules': [
        { name: 'SIM900 GSM GPRS Shield', price: 'K1000', category: 'Communication Modules', description: 'SIM900 GSM GPRS shield for cellular communication and SMS/call functionality.', keywords: ['sim900', 'gsm', 'gprs', 'shield', 'cellular', 'sms', 'call'] },
        { name: 'SIM800L GSM Module + Antenna', price: 'K800', category: 'Communication Modules', description: 'SIM800L GSM module with antenna for compact cellular communication projects.', keywords: ['sim800l', 'gsm', 'module', 'antenna', 'cellular', 'compact'] },
        { name: 'RFID Reader Set', price: 'K300', category: 'Communication Modules', description: 'RFID reader set for contactless identification and access control systems.', keywords: ['rfid', 'reader', 'set', 'contactless', 'identification', 'access'] }
      ],
      'Motors & Motor Drivers': [
        { name: 'Nema 17 Stepper Motor', price: 'K650', category: 'Motors & Motor Drivers', description: 'Nema 17 stepper motor for precise positioning in CNC and 3D printer applications.', keywords: ['nema', '17', 'stepper', 'motor', 'precise', 'positioning', 'cnc', '3d'] },
        { name: 'L298N Motor Driver', price: 'K250', category: 'Motors & Motor Drivers', description: 'L298N dual motor driver for controlling DC motors and stepper motors.', keywords: ['l298n', 'motor', 'driver', 'dual', 'dc', 'stepper', 'control'] },
        { name: 'L293D Motor Driver IC', price: 'K100', category: 'Motors & Motor Drivers', description: 'L293D motor driver IC for small DC motor control applications.', keywords: ['l293d', 'motor', 'driver', 'ic', 'small', 'dc', 'control'] },
        { name: 'TB6600 Stepper Motor Driver', price: 'K800', category: 'Motors & Motor Drivers', description: 'TB6600 stepper motor driver for high-performance stepper motor control.', keywords: ['tb6600', 'stepper', 'motor', 'driver', 'high-performance', 'control'] },
        { name: '45g SpringRC Servo Motor', price: 'K650', category: 'Motors & Motor Drivers', description: '45g SpringRC servo motor for robotics and precise angular positioning.', keywords: ['45g', 'springrc', 'servo', 'motor', 'robotics', 'angular', 'positioning'] },
        { name: '9g servo motors', price: 'K200', category: 'Motors & Motor Drivers', description: '9g micro servo motor for small robotics and RC applications.', keywords: ['9g', 'servo', 'motor', 'micro', 'small', 'robotics', 'rc'] }
      ],
      'Relay Modules & Power Control': [
        { name: '5V 4-Channel Relay Module', price: 'K350', category: 'Relay Modules & Power Control', description: '5V 4-channel relay module for controlling multiple high-power devices.', keywords: ['5v', '4-channel', 'relay', 'module', 'multiple', 'high-power'] },
        { name: '5V 10A Single-Channel Relay', price: 'K150', category: 'Relay Modules & Power Control', description: '5V 10A single-channel relay for high-current switching applications.', keywords: ['5v', '10a', 'single-channel', 'relay', 'high-current', 'switching'] },
        { name: '5V 2-Channel Relay (Jumper)', price: 'K250', category: 'Relay Modules & Power Control', description: '5V 2-channel relay module with jumper connections for dual device control.', keywords: ['5v', '2-channel', 'relay', 'jumper', 'dual', 'device'] },
        { name: '5V 2-Channel Relay (Screw)', price: 'K250', category: 'Relay Modules & Power Control', description: '5V 2-channel relay module with screw terminals for secure connections.', keywords: ['5v', '2-channel', 'relay', 'screw', 'terminals', 'secure'] },
        { name: '5V 1-Channel Relay (Screw)', price: 'K150', category: 'Relay Modules & Power Control', description: '5V single-channel relay with screw terminals for single device control.', keywords: ['5v', '1-channel', 'relay', 'screw', 'single', 'device'] }
      ],
      'Power Supply & Voltage Regulators': [
        { name: '7805 / 7812 Voltage Regulators', price: 'K65', category: 'Power Supply & Voltage Regulators', description: '7805/7812 voltage regulators for stable 5V/12V power supply in circuits.', keywords: ['7805', '7812', 'voltage', 'regulator', 'stable', '5v', '12v'] },
        { name: 'LM2596 DC-DC Step-down Module', price: 'K250', category: 'Power Supply & Voltage Regulators', description: 'LM2596 DC-DC step-down module for efficient voltage conversion.', keywords: ['lm2596', 'dc-dc', 'step-down', 'module', 'efficient', 'conversion'] },
        { name: '9V, 1A DC Power Supply', price: 'K300', category: 'Power Supply & Voltage Regulators', description: '9V 1A DC power supply adapter for powering Arduino and electronic projects.', keywords: ['9v', '1a', 'dc', 'power', 'supply', 'adapter', 'arduino'] },
        { name: '9V Battery Clip Holder with DC Jack', price: 'K95', category: 'Power Supply & Voltage Regulators', description: '9V battery clip holder with DC jack for portable power solutions.', keywords: ['9v', 'battery', 'clip', 'holder', 'dc', 'jack', 'portable'] },
        { name: '9V Snap Power Cable with DC Jack', price: 'K95', category: 'Power Supply & Voltage Regulators', description: '9V snap power cable with DC jack for easy battery connection.', keywords: ['9v', 'snap', 'power', 'cable', 'dc', 'jack', 'battery'] },
        { name: '9V Battery (Non-rechargeable)', price: 'K85', category: 'Power Supply & Voltage Regulators', description: '9V non-rechargeable battery for powering electronic projects.', keywords: ['9v', 'battery', 'non-rechargeable', 'electronic', 'projects'] }
      ],
      'Breadboards, Kits & Misc': [
        { name: 'Breadboard Jumper Wires (per piece)', price: 'K8', category: 'Breadboards, Kits & Misc', description: 'Individual breadboard jumper wires for prototyping and circuit connections.', keywords: ['breadboard', 'jumper', 'wires', 'prototyping', 'circuit', 'connections'] },
        { name: '830 Point Breadboard', price: 'K250', category: 'Breadboards, Kits & Misc', description: '830 tie-point breadboard for large circuit prototyping and testing.', keywords: ['830', 'point', 'breadboard', 'large', 'circuit', 'prototyping'] },
        { name: '170 Point Breadboard', price: 'K130', category: 'Breadboards, Kits & Misc', description: '170 tie-point mini breadboard for small circuit prototyping.', keywords: ['170', 'point', 'breadboard', 'mini', 'small', 'circuit'] },
        { name: '400P Breadboard', price: 'K200', category: 'Breadboards, Kits & Misc', description: '400 tie-point breadboard for medium-sized circuit prototyping.', keywords: ['400p', 'breadboard', 'medium', 'circuit', 'prototyping'] },
        { name: 'NE555 Timer IC', price: 'K105', category: 'Breadboards, Kits & Misc', description: 'NE555 timer IC for timing circuits and oscillator applications.', keywords: ['ne555', 'timer', 'ic', 'timing', 'circuits', 'oscillator'] },
        { name: 'DFPlayer Mini MP3 Module', price: 'K200', category: 'Breadboards, Kits & Misc', description: 'DFPlayer Mini MP3 module for audio playback in electronic projects.', keywords: ['dfplayer', 'mini', 'mp3', 'module', 'audio', 'playback'] }
      ],
      'Other Components': [
        { name: 'USB to TTL Converter', price: 'K250', category: 'Other Components', description: 'USB to TTL converter for serial communication and programming applications.', keywords: ['usb', 'ttl', 'converter', 'serial', 'communication', 'programming'] },
        { name: 'DS3231 RTC Clock Module', price: 'K250', category: 'Other Components', description: 'DS3231 real-time clock module for accurate timekeeping in projects.', keywords: ['ds3231', 'rtc', 'clock', 'module', 'real-time', 'timekeeping'] },
        { name: 'PAM8403 Audio Amplifier Module', price: 'K120', category: 'Other Components', description: 'PAM8403 audio amplifier module for sound amplification in audio projects.', keywords: ['pam8403', 'audio', 'amplifier', 'module', 'sound', 'amplification'] },
        { name: '12V DC Small Electromagnetic Lock', price: 'K350', category: 'Other Components', description: '12V DC small electromagnetic lock for access control and security systems.', keywords: ['12v', 'dc', 'electromagnetic', 'lock', 'access', 'control', 'security'] },
        { name: '20KG Load Cell + HX711 Module', price: 'K450', category: 'Other Components', description: '20KG load cell with HX711 module for weight measurement and scale projects.', keywords: ['20kg', 'load', 'cell', 'hx711', 'weight', 'measurement', 'scale'] },
        { name: '5v non submissable pump +battery', price: 'K350', category: 'Other Components', description: '5V non-submersible pump with battery for water pumping applications.', keywords: ['5v', 'non-submersible', 'pump', 'battery', 'water', 'pumping'] }
      ]
    };

    // Company information
    this.companyInfo = {
      name: 'Gifted Solutions',
      email: 'giftedsolutions20@gmail.com',
      location: 'Lusaka, Chalala near Information and Communications University',
      whatsapp: '260779421717',
      website: 'https://gifted-solutions-shop.web.app/',
      social: {
        x: 'https://x.com/giftedsolutionz',
        facebook: 'https://www.facebook.com/bupelifestyle',
        tiktok: 'https://www.tiktok.com/@giftedsolutions'
      },
      services: [
        'EC3 Projects/Electronics Projects',
        'Final Year Electronics Project Assistance',
        'Project Consultation Available (at a fee)',
        'Countrywide delivery available at a fee'
      ]
    };

    this.knowledgeBase = {
      products: {
        microcontrollers: {
          keywords: ['arduino', 'uno', 'nano', 'mega', 'esp32', 'esp8266', 'microcontroller', 'board', 'atmega', 'development board'],
          products: [
            {
              name: "Arduino Uno R3",
              price: "K650",
              description: "Perfect for beginners, most popular Arduino board with USB cable included",
              features: ["14 digital I/O pins", "6 analog inputs", "USB connection", "Power jack", "ICSP header"],
              applications: ["LED control", "Sensor reading", "Motor control", "IoT projects"],
              compatibility: ["Arduino IDE", "PlatformIO", "Most shields and sensors"]
            },
            {
              name: "ESP32 Development Board",
              price: "K450",
              description: "WiFi and Bluetooth enabled microcontroller for IoT projects",
              features: ["WiFi 802.11 b/g/n", "Bluetooth 4.2", "Dual-core processor", "18 ADC channels", "3 SPI interfaces"],
              applications: ["IoT projects", "Web servers", "Bluetooth communication", "WiFi control"],
              compatibility: ["Arduino IDE", "ESP-IDF", "MicroPython"]
            },
            {
              name: "Arduino Nano",
              price: "K400",
              description: "Compact Arduino board perfect for small projects and breadboard use",
              features: ["Small form factor", "USB Mini-B connector", "14 digital I/O pins", "8 analog inputs"],
              applications: ["Wearable projects", "Small robots", "Sensor nodes", "Compact designs"],
              compatibility: ["Arduino IDE", "Breadboard friendly", "Most Arduino libraries"]
            }
          ],
          responses: [
            "🔧 I can help you choose the perfect microcontroller! Here are our popular options:\n\n• **Arduino Uno R3** (K650) - Best for beginners, includes USB cable\n• **ESP32** (K450) - WiFi & Bluetooth enabled for IoT projects\n• **Arduino Nano** (K400) - Compact design for small projects\n\nWhat type of project are you planning?",
            "💡 Microcontrollers are the brain of your projects! Tell me about your project requirements and I'll recommend the best board for you."
          ]
        },
        sensors: {
          keywords: ['sensor', 'temperature', 'humidity', 'motion', 'ultrasonic', 'pressure', 'dht22', 'pir', 'hc-sr04', 'lm35', 'mq', 'gas', 'smoke', 'fingerprint'],
          products: [
            {
              name: "DHT22 Temperature & Humidity Sensor",
              price: "K180",
              description: "High-precision digital temperature and humidity sensor",
              features: ["Temperature range: -40°C to 80°C", "Humidity range: 0-100% RH", "Digital output", "3.3V/5V compatible"],
              applications: ["Weather stations", "Home automation", "Greenhouse monitoring", "HVAC systems"],
              accuracy: "±0.5°C temperature, ±2-5% humidity"
            },
            {
              name: "HC-SR04 Ultrasonic Distance Sensor",
              price: "K120",
              description: "Non-contact distance measurement sensor using ultrasonic waves",
              features: ["Range: 2cm to 400cm", "Accuracy: 3mm", "5V operation", "Trigger and Echo pins"],
              applications: ["Robot navigation", "Parking sensors", "Water level monitoring", "Security systems"],
              interface: "Digital trigger/echo pins"
            },
            {
              name: "PIR Motion Sensor",
              price: "K150",
              description: "Passive infrared sensor for motion detection",
              features: ["Detection range: 7 meters", "120° detection angle", "3.3V/5V compatible", "Digital output"],
              applications: ["Security systems", "Automatic lighting", "Presence detection", "Energy saving"],
              sensitivity: "Adjustable via potentiometer"
            },
            {
              name: "AS608n Fingerprint Sensor",
              price: "K800",
              description: "High-quality fingerprint recognition sensor for security applications",
              features: ["Optical fingerprint scanner", "360° recognition", "UART interface", "Built-in algorithm"],
              applications: ["Access control", "Attendance systems", "Security locks", "Identity verification"],
              storage: "Up to 1000 fingerprint templates"
            }
          ],
          responses: [
            "🌡️ We have sensors for every measurement need! Popular options:\n\n• **DHT22** (K180) - Temperature & humidity with high accuracy\n• **HC-SR04** (K120) - Ultrasonic distance sensor, 2-400cm range\n• **PIR Motion** (K150) - Detect movement up to 7 meters\n• **AS608n Fingerprint** (K800) - Biometric security sensor\n\nWhat do you need to measure?",
            "📊 Sensors bring your projects to life! Tell me what you want to detect or measure, and I'll recommend the perfect sensor with specifications."
          ]
        },
        displays: {
          keywords: ['display', 'lcd', 'oled', 'led', 'screen', 'monitor', '16x2', '20x4', 'ssd1306', 'tft'],
          products: [
            {
              name: "16x2 LCD Display",
              price: "K200",
              description: "Standard character LCD display with blue backlight",
              features: ["16 characters x 2 lines", "HD44780 controller", "Blue backlight", "I2C module available"],
              applications: ["Data display", "Menu systems", "Status indicators", "Simple interfaces"],
              interface: "Parallel (4-bit/8-bit) or I2C"
            },
            {
              name: "0.96\" OLED Display",
              price: "K350",
              description: "Small OLED display with high contrast and low power consumption",
              features: ["128x64 resolution", "SSD1306 controller", "I2C/SPI interface", "White/Blue/Yellow colors"],
              applications: ["Wearables", "Small displays", "Status screens", "Graphics display"],
              power: "Very low power consumption"
            },
            {
              name: "TFT Color Display 2.4\"",
              price: "K650",
              description: "Color TFT display with touch capability",
              features: ["240x320 resolution", "65K colors", "Touch screen", "SD card slot", "Arduino library"],
              applications: ["GUI interfaces", "Image display", "Touch controls", "Data visualization"],
              controller: "ILI9341 driver"
            }
          ],
          responses: [
            "📺 Choose the perfect display for your project:\n\n• **16x2 LCD** (K200) - Simple text display with backlight\n• **0.96\" OLED** (K350) - High contrast, low power graphics\n• **2.4\" TFT Color** (K650) - Full color with touch capability\n\nWhat type of information do you need to display?",
            "🖥️ Displays make your projects interactive! Tell me about your interface needs and I'll recommend the best display option."
          ]
        },
        motors: {
          keywords: ['motor', 'servo', 'stepper', 'dc motor', 'gear motor', 'actuator', 'movement', 'rotation'],
          products: [
            {
              name: "SG90 Micro Servo Motor",
              price: "K180",
              description: "Small servo motor perfect for robotics and automation",
              features: ["180° rotation", "PWM control", "4.8V-6V operation", "Plastic gears"],
              applications: ["Robot arms", "Camera pan/tilt", "RC vehicles", "Automated mechanisms"],
              torque: "1.8 kg⋅cm at 4.8V"
            },
            {
              name: "28BYJ-48 Stepper Motor",
              price: "K250",
              description: "5V stepper motor with ULN2003 driver board",
              features: ["5V operation", "Step angle: 5.625°", "ULN2003 driver included", "4-phase motor"],
              applications: ["Precise positioning", "CNC projects", "3D printers", "Automated systems"],
              steps: "64 steps per revolution (with gearing: 4096 steps)"
            },
            {
              name: "DC Gear Motor 12V",
              price: "K320",
              description: "High-torque DC motor with gear reduction",
              features: ["12V operation", "High torque output", "Metal gears", "Mounting holes"],
              applications: ["Robot wheels", "Conveyor systems", "Heavy-duty projects", "Automation"],
              rpm: "Variable speed with PWM control"
            }
          ],
          responses: [
            "⚙️ Get your projects moving with our motors:\n\n• **SG90 Servo** (K180) - Precise 180° positioning for robotics\n• **28BYJ-48 Stepper** (K250) - Accurate step-by-step movement\n• **DC Gear Motor** (K320) - High torque for heavy-duty applications\n\nWhat type of movement do you need?",
            "🤖 Motors bring motion to your projects! Describe your movement requirements and I'll suggest the perfect motor solution."
          ]
        },
        components: {
          keywords: ['resistor', 'capacitor', 'led', 'breadboard', 'jumper', 'wire', 'component', 'transistor', 'diode', 'relay'],
          products: [
            {
              name: "Breadboard Kit",
              price: "K150",
              description: "Complete breadboard kit with jumper wires",
              features: ["830 tie points", "Color-coded jumper wires", "Reusable", "Standard spacing"],
              applications: ["Prototyping", "Circuit testing", "Learning electronics", "Temporary circuits"],
              included: "Breadboard + 65 jumper wires"
            },
            {
              name: "LED Assortment Kit",
              price: "K120",
              description: "Mixed color LED pack for various projects",
              features: ["5mm LEDs", "Multiple colors", "Standard brightness", "Long lifespan"],
              applications: ["Status indicators", "Decorative lighting", "Learning projects", "Visual feedback"],
              colors: "Red, Green, Blue, Yellow, White"
            },
            {
              name: "Resistor Kit (600pcs)",
              price: "K200",
              description: "Complete resistor assortment for all projects",
              features: ["1/4W carbon film", "1% tolerance", "30 different values", "Organized storage"],
              applications: ["Current limiting", "Voltage dividers", "Pull-up/down resistors", "General circuits"],
              range: "10Ω to 1MΩ"
            }
          ],
          responses: [
            "⚡ Essential components for every project:\n\n• **Breadboard Kit** (K150) - Prototyping made easy with jumper wires\n• **LED Assortment** (K120) - Multiple colors for indicators and lighting\n• **Resistor Kit** (K200) - 600 pieces, all values you need\n\nBuilding something specific?",
            "🔌 Quality components are the foundation of great projects! Tell me what you're building and I'll recommend the right components."
          ]
        }
      },
      support: {
        orders: {
          keywords: ['order', 'shipping', 'delivery', 'track', 'status', 'when'],
          responses: [
            "📦 I can help with your order! If you're logged in, I can check your order status. You can also:\n\n• Track your package with the tracking number\n• Contact support for detailed updates\n• Check estimated delivery times\n\nDo you have your order number?",
            "🚚 Orders typically ship within 1-2 business days. You'll receive tracking information via email once your order ships."
          ]
        },
        technical: {
          keywords: ['help', 'problem', 'not working', 'error', 'troubleshoot', 'code'],
          responses: [
            "🛠️ I'm here to help with technical issues! Common solutions:\n\n• Check all connections\n• Verify power supply\n• Review your code for syntax errors\n• Ensure proper library installation\n\nWhat specific problem are you experiencing?",
            "💻 Technical issues can be frustrating! Describe your setup and the problem you're facing - I'll guide you through troubleshooting steps."
          ]
        },
        projects: {
          keywords: ['project', 'tutorial', 'guide', 'how to', 'build', 'make'],
          responses: [
            "🎯 Project ideas and guidance:\n\n• Home automation systems\n• Weather monitoring stations\n• Robot control systems\n• IoT devices\n• LED displays\n\nWhat type of project interests you?",
            "📚 We love helping with projects! Share your idea and I'll suggest the components and approach you'll need."
          ]
        }
      },
      company: {
        about: {
          keywords: ['about', 'company', 'who', 'gifted solutions'],
          responses: [
            "🏢 Gifted Solutions is your trusted partner for electronics and Arduino components. We specialize in:\n\n• Quality electronic components\n• Arduino boards and shields\n• Educational kits\n• Project support\n• Fast shipping\n\nServing makers and engineers worldwide!",
            "✨ We're passionate about electronics education and innovation. Our mission is to provide quality components and support for your creative projects."
          ]
        },
        contact: {
          keywords: ['contact', 'phone', 'email', 'address', 'location'],
          responses: [
            "📞 You can reach us through:\n\n• Email: support@giftedsolutions.com\n• Phone: +1 (555) 123-4567\n• WhatsApp: Available 24/7\n• Live Chat: Right here!\n\nHow would you prefer to connect?",
            "🌍 We're here to help! Multiple ways to reach our support team for any questions or assistance you need."
          ]
        }
      }
    };

    this.fallbackResponses = [
      "🤖 I understand you're asking about: \"{query}\"\n\nI'm still learning, but I can help with:\n• Product information\n• Technical support\n• Order inquiries\n• Project guidance\n\nWould you like me to connect you with our human support team?",
      "💭 That's an interesting question! While I'm processing that, I can definitely help with product recommendations, technical questions, and order support.\n\nCan you tell me more about what you're looking for?",
      "🔍 I want to make sure I give you the best answer. Could you provide a bit more detail about what you need help with?\n\nI'm great at helping with Arduino projects, component selection, and technical support!"
    ];

    this.greetings = [
      "👋 Hello! I'm your AI assistant for Gifted Solutions. I'm trained on our complete product catalog with 50+ electronics components. How can I help you today?",
      "🎉 Welcome to Gifted Solutions! I know all about our Arduino boards, sensors, displays, motors, and more. What project are you working on?",
      "⚡ Hi there! Ready to bring your electronics projects to life? I can help you find the perfect components from our extensive catalog. What do you need?"
    ];
  }

  /**
   * Load product data from ProductContext
   */
  loadProductData(products, categories) {
    this.productDatabase = products || [];
    this.categories = categories || [];
    console.log(`🤖 AI trained with ${this.productDatabase.length} products and ${this.categories.length} categories`);
  }

  /**
   * Search comprehensive product database
   */
  searchProducts(query, limit = 5) {
    const lowerQuery = query.toLowerCase();
    let allProducts = [];

    // Search Gifted Solutions catalog first (priority)
    Object.values(this.giftedSolutionsProducts).forEach(categoryProducts => {
      categoryProducts.forEach(product => {
        const matchScore = this.calculateProductMatch(product, lowerQuery);
        if (matchScore > 0) {
          allProducts.push({ ...product, matchScore });
        }
      });
    });

    // Also search loaded product database if available
    if (this.productDatabase && this.productDatabase.length > 0) {
      this.productDatabase.forEach(product => {
        const matchScore = this.calculateProductMatch(product, lowerQuery);
        if (matchScore > 0) {
          allProducts.push({ ...product, matchScore });
        }
      });
    }

    // Sort by match score and remove duplicates
    allProducts.sort((a, b) => b.matchScore - a.matchScore);
    const uniqueProducts = allProducts.filter((product, index, self) =>
      index === self.findIndex(p => p.name === product.name)
    );

    return uniqueProducts.slice(0, limit);
  }

  /**
   * Calculate product match score
   */
  calculateProductMatch(product, query) {
    let score = 0;

    // Exact name match (highest priority)
    if (product.name?.toLowerCase().includes(query)) {
      score += 10;
    }

    // Category match
    if (product.category?.toLowerCase().includes(query)) {
      score += 8;
    }

    // Description match
    if (product.description?.toLowerCase().includes(query)) {
      score += 6;
    }

    // Keywords match
    if (product.keywords) {
      product.keywords.forEach(keyword => {
        if (keyword.toLowerCase().includes(query) || query.includes(keyword.toLowerCase())) {
          score += 5;
        }
      });
    }

    // Partial matches
    const queryWords = query.split(' ');
    queryWords.forEach(word => {
      if (word.length > 2) {
        if (product.name?.toLowerCase().includes(word)) score += 3;
        if (product.description?.toLowerCase().includes(word)) score += 2;
      }
    });

    return score;
  }

  /**
   * Get products by category
   */
  getProductsByCategory(category, limit = 5) {
    let categoryProducts = [];

    // Search Gifted Solutions catalog
    const categoryKey = Object.keys(this.giftedSolutionsProducts).find(key =>
      key.toLowerCase().includes(category.toLowerCase()) ||
      category.toLowerCase().includes(key.toLowerCase())
    );

    if (categoryKey) {
      categoryProducts = [...this.giftedSolutionsProducts[categoryKey]];
    }

    // Also search loaded product database
    if (this.productDatabase && this.productDatabase.length > 0) {
      const dbProducts = this.productDatabase.filter(product =>
        product.category?.toLowerCase().includes(category.toLowerCase())
      );
      categoryProducts = [...categoryProducts, ...dbProducts];
    }

    // Remove duplicates and limit results
    const uniqueProducts = categoryProducts.filter((product, index, self) =>
      index === self.findIndex(p => p.name === product.name)
    );

    return uniqueProducts.slice(0, limit);
  }

  /**
   * Get product recommendations based on query
   */
  getProductRecommendations(query, context = {}) {
    const products = this.searchProducts(query, 3);

    if (products.length === 0) {
      return null;
    }

    let response = "🛍️ Here are some products that match your needs:\n\n";

    products.forEach((product, index) => {
      response += `**${product.name}**\n`;
      response += `💰 Price: ${product.price}\n`;
      response += `📦 Category: ${product.category}\n`;

      if (product.description) {
        const shortDesc = product.description.length > 100
          ? product.description.substring(0, 100) + "..."
          : product.description;
        response += `📝 ${shortDesc}\n`;
      }

      if (product.inStock !== false) {
        response += `✅ In Stock\n`;
      } else {
        response += `❌ Out of Stock\n`;
      }

      if (index < products.length - 1) {
        response += "\n";
      }
    });

    response += "\n💬 Would you like more details about any of these products?";
    return response;
  }

  /**
   * Generate category overview
   */
  getCategoryOverview(category) {
    const products = this.getProductsByCategory(category, 6);

    if (products.length === 0) {
      return `📂 We have products in the ${category} category, but I don't have specific details loaded right now. Please check our shop page for the latest ${category} products!`;
    }

    // Find the exact category name from our catalog
    const categoryKey = Object.keys(this.giftedSolutionsProducts).find(key =>
      key.toLowerCase().includes(category.toLowerCase()) ||
      category.toLowerCase().includes(key.toLowerCase())
    );

    const categoryName = categoryKey || category;
    const categoryIcon = this.getCategoryIcon(categoryName);

    let response = `${categoryIcon} **${categoryName}** (${products.length} products):\n\n`;

    products.forEach((product, index) => {
      response += `• **${product.name}** - ${product.price}\n`;
      if (index < 3 && product.description) {
        const shortDesc = product.description.length > 80
          ? product.description.substring(0, 80) + "..."
          : product.description;
        response += `  ${shortDesc}\n`;
      }
      if (index < products.length - 1) response += "\n";
    });

    response += `\n💬 Ask me about any specific product for detailed information!`;
    response += `\n📱 WhatsApp: ${this.companyInfo.whatsapp} for orders`;
    return response;
  }

  /**
   * Get category icon
   */
  getCategoryIcon(category) {
    const icons = {
      'Arduino & Development Boards': '🧰',
      'Sensors & Modules': '🔍',
      'Display & Interface Modules': '📺',
      'Communication Modules': '📡',
      'Motors & Motor Drivers': '⚙️',
      'Relay Modules & Power Control': '🔌',
      'Power Supply & Voltage Regulators': '🔋',
      'Breadboards, Kits & Misc': '🛠️',
      'Other Components': '🔄'
    };
    return icons[category] || '📦';
  }

  /**
   * Get detailed product information
   */
  getProductDetails(productName) {
    let product = null;

    // Search in Gifted Solutions catalog
    Object.values(this.giftedSolutionsProducts).forEach(categoryProducts => {
      const found = categoryProducts.find(p =>
        p.name.toLowerCase().includes(productName.toLowerCase()) ||
        productName.toLowerCase().includes(p.name.toLowerCase())
      );
      if (found) product = found;
    });

    if (!product) return null;

    let response = `🛍️ **${product.name}**\n\n`;
    response += `💰 **Price:** ${product.price}\n`;
    response += `📦 **Category:** ${product.category}\n\n`;
    response += `📝 **Description:**\n${product.description}\n\n`;

    if (product.keywords && product.keywords.length > 0) {
      response += `🏷️ **Tags:** ${product.keywords.join(', ')}\n\n`;
    }

    response += `📞 **Order Information:**\n`;
    response += `• WhatsApp: ${this.companyInfo.whatsapp}\n`;
    response += `• Email: ${this.companyInfo.email}\n`;
    response += `• Location: ${this.companyInfo.location}\n\n`;
    response += `🚚 Countrywide delivery available!`;

    return response;
  }

  /**
   * Get price range for category
   */
  getCategoryPriceRange(category) {
    const products = this.getProductsByCategory(category, 20);

    if (products.length === 0) return null;

    const prices = products.map(p => {
      const priceStr = p.price.replace(/[^\d]/g, '');
      return parseInt(priceStr) || 0;
    }).filter(p => p > 0);

    if (prices.length === 0) return null;

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);

    return {
      min: `K${minPrice}`,
      max: `K${maxPrice}`,
      range: `K${minPrice} - K${maxPrice}`
    };
  }

  /**
   * Generate AI response based on user input
   */
  async generateResponse(message, context = {}) {
    const lowerMessage = message.toLowerCase();

    // Check for greetings
    if (this.isGreeting(lowerMessage)) {
      return this.getRandomResponse(this.greetings);
    }

    // Check for company/contact information requests
    if (this.isContactInquiry(lowerMessage)) {
      return this.getContactInformation();
    }

    // Check for services inquiry
    if (this.isServicesInquiry(lowerMessage)) {
      return this.getServicesInformation();
    }

    // Check for specific product details
    const productDetails = this.getProductDetails(message);
    if (productDetails) {
      return productDetails;
    }

    // Check for specific product searches
    const productRecommendation = this.getProductRecommendations(message, context);
    if (productRecommendation) {
      return productRecommendation;
    }

    // Check for category requests
    const categoryMatch = this.detectCategoryRequest(lowerMessage);
    if (categoryMatch) {
      return this.getCategoryOverview(categoryMatch);
    }

    // Check for price inquiries
    if (this.isPriceInquiry(lowerMessage)) {
      return this.handlePriceInquiry(message, context);
    }

    // Check for stock inquiries
    if (this.isStockInquiry(lowerMessage)) {
      return this.handleStockInquiry(message, context);
    }

    // Check for project help requests
    if (this.isProjectInquiry(lowerMessage)) {
      return this.handleProjectInquiry(message, context);
    }

    // Search knowledge base
    const response = this.searchKnowledgeBase(lowerMessage);
    if (response) {
      return response;
    }

    // Enhanced fallback with product suggestions
    return this.getEnhancedFallbackResponse(message);
  }

  /**
   * Check if message is a greeting
   */
  isGreeting(message) {
    const greetingKeywords = ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening'];
    return greetingKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Detect category requests
   */
  detectCategoryRequest(message) {
    // Check for exact category matches from our catalog
    const categoryKeys = Object.keys(this.giftedSolutionsProducts);

    for (const categoryKey of categoryKeys) {
      const categoryWords = categoryKey.toLowerCase().split(/[\s&]+/);
      if (categoryWords.some(word => message.includes(word))) {
        return categoryKey;
      }
    }

    // Check for specific category keywords
    if (message.includes('arduino') || message.includes('esp32') || message.includes('board') || message.includes('microcontroller')) {
      return 'Arduino & Development Boards';
    }
    if (message.includes('sensor') || message.includes('temperature') || message.includes('humidity') || message.includes('motion')) {
      return 'Sensors & Modules';
    }
    if (message.includes('lcd') || message.includes('oled') || message.includes('display') || message.includes('screen')) {
      return 'Display & Interface Modules';
    }
    if (message.includes('servo') || message.includes('stepper') || message.includes('motor') || message.includes('driver')) {
      return 'Motors & Motor Drivers';
    }
    if (message.includes('relay') || message.includes('power control')) {
      return 'Relay Modules & Power Control';
    }
    if (message.includes('power supply') || message.includes('voltage') || message.includes('regulator')) {
      return 'Power Supply & Voltage Regulators';
    }
    if (message.includes('breadboard') || message.includes('jumper') || message.includes('wire')) {
      return 'Breadboards, Kits & Misc';
    }
    if (message.includes('gsm') || message.includes('wifi') || message.includes('bluetooth') || message.includes('communication')) {
      return 'Communication Modules';
    }

    return null;
  }

  /**
   * Check for contact information requests
   */
  isContactInquiry(message) {
    const contactKeywords = ['contact', 'phone', 'email', 'address', 'location', 'whatsapp', 'reach', 'call'];
    return contactKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Check for services inquiry
   */
  isServicesInquiry(message) {
    const serviceKeywords = ['service', 'project', 'consultation', 'help', 'assistance', 'delivery'];
    return serviceKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Check for project inquiry
   */
  isProjectInquiry(message) {
    const projectKeywords = ['project', 'build', 'make', 'create', 'tutorial', 'guide', 'how to'];
    return projectKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Get contact information
   */
  getContactInformation() {
    let response = `📞 **Contact Gifted Solutions:**\n\n`;
    response += `📧 **Email:** ${this.companyInfo.email}\n`;
    response += `📱 **WhatsApp:** +${this.companyInfo.whatsapp}\n`;
    response += `📍 **Location:** ${this.companyInfo.location}\n`;
    response += `🌐 **Website:** ${this.companyInfo.website}\n\n`;

    response += `**Social Media:**\n`;
    response += `• X (Twitter): ${this.companyInfo.social.x}\n`;
    response += `• Facebook: ${this.companyInfo.social.facebook}\n`;
    response += `• TikTok: ${this.companyInfo.social.tiktok}\n\n`;

    response += `🚚 **Delivery:** Countrywide delivery available at a fee\n`;
    response += `⏰ **Response Time:** Usually within 30 minutes during business hours`;

    return response;
  }

  /**
   * Get services information
   */
  getServicesInformation() {
    let response = `🛠️ **Gifted Solutions Services:**\n\n`;

    this.companyInfo.services.forEach((service, index) => {
      response += `${index + 1}. ${service}\n`;
    });

    response += `\n💡 **Specializations:**\n`;
    response += `• Arduino & ESP32 Projects\n`;
    response += `• IoT Solutions\n`;
    response += `• Sensor Integration\n`;
    response += `• Automation Systems\n`;
    response += `• Custom Electronics Design\n\n`;

    response += `📞 Contact us for project consultation and technical support!\n`;
    response += `📱 WhatsApp: +${this.companyInfo.whatsapp}`;

    return response;
  }

  /**
   * Handle project inquiries
   */
  handleProjectInquiry(message, context) {
    let response = `🚀 **Project Assistance Available!**\n\n`;

    // Suggest relevant products based on project keywords
    const projectProducts = this.searchProducts(message, 3);

    if (projectProducts.length > 0) {
      response += `💡 **Recommended Components:**\n`;
      projectProducts.forEach(product => {
        response += `• **${product.name}** (${product.price}) - ${product.category}\n`;
      });
      response += `\n`;
    }

    response += `🛠️ **Our Project Services:**\n`;
    response += `• EC3 Projects/Electronics Projects\n`;
    response += `• Final Year Electronics Project Assistance\n`;
    response += `• Project Consultation (at a fee)\n`;
    response += `• Technical Support & Guidance\n\n`;

    response += `📚 **Project Categories We Help With:**\n`;
    response += `• IoT & Smart Home Systems\n`;
    response += `• Robotics & Automation\n`;
    response += `• Sensor Networks\n`;
    response += `• Data Logging Systems\n`;
    response += `• Communication Projects\n\n`;

    response += `📞 **Get Started:**\n`;
    response += `WhatsApp: +${this.companyInfo.whatsapp}\n`;
    response += `Email: ${this.companyInfo.email}\n\n`;
    response += `💬 Tell me more about your project idea for specific component recommendations!`;

    return response;
  }

  /**
   * Check if message is asking about prices
   */
  isPriceInquiry(message) {
    const priceKeywords = ['price', 'cost', 'how much', 'expensive', 'cheap', 'budget', 'pricing'];
    return priceKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Check if message is asking about stock
   */
  isStockInquiry(message) {
    const stockKeywords = ['stock', 'available', 'in stock', 'out of stock', 'availability'];
    return stockKeywords.some(keyword => message.includes(keyword));
  }

  /**
   * Handle price inquiries
   */
  handlePriceInquiry(message, context) {
    const products = this.searchProducts(message, 3);

    if (products.length > 0) {
      let response = "💰 **Current Pricing:**\n\n";
      products.forEach(product => {
        response += `• **${product.name}** - ${product.price}\n`;
      });
      response += "\n💡 Prices include quality guarantee and technical support!";
      return response;
    }

    return "💰 Our products are competitively priced! Here are some popular price ranges:\n\n• **Microcontrollers**: K400-K650\n• **Sensors**: K120-K800\n• **Displays**: K200-K650\n• **Motors**: K180-K320\n• **Component Kits**: K120-K200\n\n🔍 Tell me what specific product you're interested in for exact pricing!";
  }

  /**
   * Handle stock inquiries
   */
  handleStockInquiry(message, context) {
    const products = this.searchProducts(message, 3);

    if (products.length > 0) {
      let response = "📦 **Stock Status:**\n\n";
      products.forEach(product => {
        const stockStatus = product.inStock !== false ? "✅ In Stock" : "❌ Out of Stock";
        response += `• **${product.name}** - ${stockStatus}\n`;
      });
      response += "\n📱 Contact us for bulk orders or special requests!";
      return response;
    }

    return "📦 Most of our products are in stock and ready to ship!\n\n✅ **Usually Available:**\n• Arduino boards\n• Common sensors\n• Basic components\n• Display modules\n\n🔍 Tell me what specific product you need and I'll check availability!";
  }

  /**
   * Enhanced fallback response with product suggestions
   */
  getEnhancedFallbackResponse(originalMessage) {
    // Try to suggest related products based on keywords
    const keywords = originalMessage.toLowerCase().split(' ');
    let suggestions = [];

    keywords.forEach(keyword => {
      if (keyword.length > 3) { // Only check meaningful words
        const relatedProducts = this.searchProducts(keyword, 2);
        suggestions = [...suggestions, ...relatedProducts];
      }
    });

    // Remove duplicates
    suggestions = suggestions.filter((product, index, self) =>
      index === self.findIndex(p => p.id === product.id)
    ).slice(0, 3);

    let response = `🤖 I understand you're asking about: "${originalMessage}"\n\n`;

    if (suggestions.length > 0) {
      response += "💡 Based on your message, you might be interested in:\n\n";
      suggestions.forEach(product => {
        response += `• **${product.name}** (${product.price}) - ${product.category}\n`;
      });
      response += "\n";
    }

    response += "I can help with:\n";
    response += "• 🔍 Product recommendations\n";
    response += "• 💰 Pricing information\n";
    response += "• 📦 Stock availability\n";
    response += "• 🛠️ Technical specifications\n";
    response += "• 🚀 Project guidance\n\n";
    response += "What would you like to know more about?";

    return response;
  }

  /**
   * Search knowledge base for relevant response
   */
  searchKnowledgeBase(message) {
    let bestMatch = null;
    let maxScore = 0;

    // Search through all categories
    for (const category in this.knowledgeBase) {
      for (const subcategory in this.knowledgeBase[category]) {
        const item = this.knowledgeBase[category][subcategory];
        const score = this.calculateRelevanceScore(message, item.keywords);
        
        if (score > maxScore && score > 0.3) { // Minimum relevance threshold
          maxScore = score;
          bestMatch = item;
        }
      }
    }

    if (bestMatch) {
      return this.getRandomResponse(bestMatch.responses);
    }

    return null;
  }

  /**
   * Calculate relevance score based on keyword matching
   */
  calculateRelevanceScore(message, keywords) {
    let score = 0;
    const messageWords = message.split(' ');
    
    keywords.forEach(keyword => {
      if (message.includes(keyword)) {
        score += 1;
        // Bonus for exact word match
        if (messageWords.includes(keyword)) {
          score += 0.5;
        }
      }
    });

    return score / keywords.length;
  }

  /**
   * Get random response from array
   */
  getRandomResponse(responses) {
    return responses[Math.floor(Math.random() * responses.length)];
  }

  /**
   * Get fallback response when no match found
   */
  getFallbackResponse(originalMessage) {
    const response = this.getRandomResponse(this.fallbackResponses);
    return response.replace('{query}', originalMessage);
  }

  /**
   * Get suggested follow-up questions
   */
  getSuggestions(context = {}) {
    const suggestions = [
      "Tell me about Arduino boards",
      "What sensors do you have?",
      "Help with my project",
      "Check order status",
      "Technical support",
      "Contact information"
    ];

    return suggestions.slice(0, 4); // Return 4 suggestions
  }

  /**
   * Analyze user intent
   */
  analyzeIntent(message) {
    const lowerMessage = message.toLowerCase();
    
    if (lowerMessage.includes('buy') || lowerMessage.includes('purchase') || lowerMessage.includes('order')) {
      return 'purchase';
    }
    
    if (lowerMessage.includes('help') || lowerMessage.includes('support') || lowerMessage.includes('problem')) {
      return 'support';
    }
    
    if (lowerMessage.includes('product') || lowerMessage.includes('arduino') || lowerMessage.includes('sensor')) {
      return 'product_inquiry';
    }
    
    if (lowerMessage.includes('project') || lowerMessage.includes('tutorial') || lowerMessage.includes('how to')) {
      return 'project_help';
    }
    
    return 'general';
  }

  /**
   * Check if human handoff is needed
   */
  needsHumanHandoff(message, conversationHistory = []) {
    const complexKeywords = [
      'speak to human', 'talk to person', 'customer service', 'manager',
      'complaint', 'refund', 'return', 'cancel order', 'billing issue'
    ];
    
    const lowerMessage = message.toLowerCase();
    
    // Check for explicit human request
    if (complexKeywords.some(keyword => lowerMessage.includes(keyword))) {
      return true;
    }
    
    // Check conversation length (handoff after too many exchanges)
    if (conversationHistory.length > 10) {
      return true;
    }
    
    return false;
  }

  /**
   * Format response with suggestions
   */
  formatResponse(message, suggestions = null) {
    return {
      message,
      suggestions: suggestions || this.getSuggestions(),
      timestamp: new Date(),
      type: 'ai'
    };
  }
}

// Create singleton instance
const aiChatService = new AIChatService();

export default aiChatService;
